import { Cloud } from '@silbo/core';
import { useQuery } from '@tanstack/react-query';
import React, { useEffect, useMemo, useState } from 'react';
import { getPortersQueryOptions } from '../queries/get-porters/get-porters-query-options';
import { useHealthCenterContext } from '../../../contexts/HealthCenterContext/useHealthCenterContext';
import { PortersContext } from './PortersContext';
import { PortersContextType } from './types';

export const PortersProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [porters, setPorters] = useState<Cloud.PublicPorter[]>([]);
  const { healthCenterConfig } = useHealthCenterContext();
  const { data: fetchedPorters, isLoading } = useQuery(
    getPortersQueryOptions(healthCenterConfig.id, healthCenterConfig.key)
  );

  useEffect(() => {
    if (fetchedPorters) setPorters(fetchedPorters);
  }, [fetchedPorters]);

  const value = useMemo<PortersContextType>(() => ({ porters, isLoading, setPorters }), [porters, isLoading]);

  return <PortersContext.Provider value={value}>{children}</PortersContext.Provider>;
};
